import { useDispatch } from "react-redux";

import { LoginResponseBodyType } from "@intelligems/ig-types/functions/user-auths/login";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearDashboardFilters } from "../../store/slices/dashboardFilters";
import { clearSitewideDashboardFilters } from "../../store/slices/sitewideDashboardFilters";
import { IgStorage } from "../../utils/igStorage";
import { message } from "../../utils/message";
import { organizationsKeys, userKeys } from "../queryKeys";
import { leaveForLoginExit } from "../user-auths/leave-for-login-exit";

import { switchOrganization } from "./switch-organization";

export const useSwitchWidgetOrganization = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation<LoginResponseBodyType, Error, any, any>({
    mutationKey: [{ scope: "user" }],
    mutationFn: async (body: { token: string; orgId: string }) =>
      switchOrganization(body.token, body.orgId),
    onSuccess: async (data) => {
      if (data.type !== "login") {
        return leaveForLoginExit(data);
      }
      // eslint-disable-next-line react-compiler/react-compiler
      IgStorage.authToken = data.token;
      // This should hopefully return the correct org since we just switched
      const org = data.organization;
      message({
        type: "LOGGED_IN",
        payload: {
          id: org?.id,
          name: org?.name,
          shopId: org?.shopId,
          token: data.token,
        },
      });
      dispatch(clearDashboardFilters());
      dispatch(clearSitewideDashboardFilters());
      queryClient.clear();
      queryClient.setQueryData(userKeys.all, data);
      queryClient.setQueryData(organizationsKeys.one, {
        org: data.organization,
      });
      window.close();
    },
  });
};
